import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { BookOpen, Brain, ClipboardList, MessageSquare } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();

  const { data: stats } = useQuery({
    queryKey: ['public-stats'],
    queryFn: async () => {
      const { data } = await supabase.rpc('get_public_stats');
      return data as { courses: number; lessons: number; tasks: number; questions: number } | null;
    },
    staleTime: 5 * 60 * 1000,
  });

  const statItems = stats
    ? [
        { icon: BookOpen, label: t('footer.courses'), value: stats.courses },
        { icon: Brain, label: t('footer.lessons'), value: stats.lessons },
        { icon: ClipboardList, label: t('footer.tasks'), value: stats.tasks },
        { icon: MessageSquare, label: t('footer.questions'), value: stats.questions },
      ]
    : [];

  return (
    <footer className="border-t bg-muted/50 py-4">
      <div className="container">
        {stats && (
          <div className="flex flex-wrap items-center justify-center gap-6 mb-4 text-sm text-muted-foreground">
            {statItems.map((item) => (
              <div key={item.label} className="flex items-center gap-1.5">
                <item.icon className="h-4 w-4" />
                <span className="font-semibold text-foreground">{item.value.toLocaleString()}</span>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        )}
        <div className="flex flex-col items-center gap-2 lg:flex-row lg:justify-center lg:relative">
          <nav className="flex flex-wrap items-center justify-center gap-4 text-sm text-muted-foreground">
            <Link to="/terms" className="hover:text-foreground transition-colors">
              {t('footer.terms')}
            </Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              {t('footer.privacy')}
            </Link>
            <Link to="/articles?category=about_me" className="hover:text-foreground transition-colors">
              {t('footer.contact')}
            </Link>
          </nav>
          <p className="text-xs text-muted-foreground lg:absolute lg:right-0">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
      </div>
    </footer>
  );
};
